import { Role } from "constant/Role"

export const FALLBACK_ELIGIBLE_ROLES = [Role.PROCUREMENT, Role.REQUESTER]

// Matches ROLE_REQUESTER or any role with ROLE_PROCUREMENT prefix (ROLE_PROCUREMENT, ROLE_PROCUREMENT_APPROVER, …)
// Kept for JWT-level "does this user hold a procurement-flavoured role" checks
// outside sidenav gating (see PROCUREMENT_MENU_ACCESS in menuAccess.js for
// sidebar visibility, the actual source of truth accessibleRoutes.js reads).
export const isProcurementEligible = (roles = []) =>
  roles.some((r) => r === Role.REQUESTER || r.startsWith("ROLE_PROCUREMENT"))

// Any role code containing "MANAGER" (ROLE_CENTRE_MANAGER, ROLE_PROCUREMENT_MANAGER,
// any future *_MANAGER role) is treated as an approver-eligible role — this is
// what gates appending managerOrderApprovalRoutes in App.js so department
// heads / center managers get an "Approve Order" entry without needing the
// full Procurement Manager workspace. ROLE_PROCUREMENT_MANAGER itself is
// excluded by the caller (its own menu already has Order approval built in).
export const isManagerRole = (roleCode) =>
  typeof roleCode === "string" && roleCode.includes("MANAGER")

// Any role code containing "FINANCE" (ROLE_FINANCE, any future ROLE_FINANCE_*)
// owns the approval decisions on a Payment Request. The backend's approval-rule
// engine can be configured to route a payment approval to a Procurement or
// Manager approver, but the UI refuses to offer those buttons to anyone else —
// see PaymentRequestActionBar. Checked against the *active* role, not the full
// JWT role list, so a dual-role user must switch to Finance to decide.
export const isFinanceRole = (roleCode) =>
  typeof roleCode === "string" && roleCode.includes("FINANCE")

// A user holding both ROLE_PROCUREMENT and ROLE_PROCUREMENT_MANAGER should
// default to the Manager role — it's a strict superset (approvals + oversight
// on top of the base requester surface), and the manager menu (procurement
// approvals inbox, org-wide orders) is only reachable while it's active.
// Only overrides the login-suggested role when it's exactly ROLE_PROCUREMENT;
// any other suggested role (e.g. TEACHER, with Procurement Manager only as a
// secondary role) is left alone.
export const preferProcurementManager = (roleCode, roles = []) =>
  roleCode === Role.PROCUREMENT && roles.includes(Role.PROCUREMENT_MANAGER)
    ? Role.PROCUREMENT_MANAGER
    : roleCode
